<template>
  <div
    class="flex items-center w-full"
    :class="isCollapsed ? 'justify-center' : 'justify-between'"
  >
    <Transition name="fade">
      <img v-if="!isCollapsed" :src="logo" alt="logo" class="logo" />
    </Transition>

    <Button
      v-if="!isMobile"
      variant="outline"
      size="icon"
      class="shrink-0 icon"
      @click="$emit('toggleSidebarHandler')"
    >
      <svg-icon
        name="sli-right"
        :class="['w-4 h-4', { 'rotate-180': !isCollapsed }]"
      />
    </Button>
  </div>
</template>

<script>
import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "SidebarHeader",
  components: { Button },
  props: {
    isCollapsed: {
      type: Boolean,
    },
    logo: {
      type: String,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["toggleSidebarHandler"],
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity 0.14s ease;
  transition-delay: 0.1s;
}
.fade-leave-active {
  transition: opacity 0.16s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.logo {
  @apply w-auto;
  height: 30px;
}

.icon {
  width: 34px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
